import React from 'react';
import { Stack, Inline } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';

export const TemplatesListLoadingView = () => (
	<Stack
		space="space.200"
		testId="playbooks-list-screen.ui.playbook-templates.edge-cases.templates-list-loading-view"
	>
		<Skeleton height={20} width={220} borderRadius={4} isShimmering />
		<Inline space="space.200">
			<Skeleton height={282} width={272} borderRadius={8} isShimmering />
			<Skeleton height={282} width={272} borderRadius={8} isShimmering />
		</Inline>
	</Stack>
);
